import { ComponentListenerDefs } from "../../base/ComponentListenerDefs";
import { Table } from "./Table";
import { TableHeadingRowStyles } from "./TableHeadingRowStyles";
import { TableRow } from "./TableRow";
import { TableRowProps } from "./TableRowProps";

export class TableHeadingRow extends TableRow {
    constructor(table: Table) {
        const props: Partial<TableRowProps> = {
            allowEdit: false,
            allowDelete: false,
            className: TableHeadingRowStyles.base,
            cursor: null,
            table,
            virtualized: false
        };
        super(props);

        // Since the heading row is built as the columns are added, go ahead and consider it 'populated' from the start
        this.populatedDOM = true;

        this.removeAllEventListeners(ComponentListenerDefs.click);
        this.removeAllEventListeners(ComponentListenerDefs.dblclick);
        // this.cursor = null;
    }

    public get populatedDOM(): boolean {
        return super.populatedDOM;
    }

    protected set populatedDOM(_value: boolean) {
        // Heading rows are always considered to be populated
        super.populatedDOM = true;
    }
}
